import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useProvince } from "@/contexts/ProvinceContext";
import { Facebook, Instagram, Youtube, Twitter, Send } from "lucide-react";

export default function SocialMediaBlock() {
  const { selected } = useProvince();
  const [social, setSocial] = useState({});
  useEffect(() => {
    api.get(`/social-media${selected ? `?province_id=${selected.id}` : ""}`).then((r) => setSocial(r.data || {})).catch(() => {});
  }, [selected?.id]);
  const links = [
    { key: "facebook", icon: Facebook, label: "Facebook", color: "#1877F2" },
    { key: "instagram", icon: Instagram, label: "Instagram", color: "#E1306C" },
    { key: "twitter", icon: Twitter, label: "X", color: "#000" },
    { key: "youtube", icon: Youtube, label: "YouTube", color: "#FF0000" },
    { key: "telegram", icon: Send, label: "Telegram", color: "#26A5E4" },
  ];
  return (
    <div className="w-full bg-white rounded-lg border border-gray-100 p-5">
      <h3 className="text-lg font-black mb-3">SOSYAL MEDYA HESAPLARIMIZ</h3>
      <div className="grid grid-cols-5 gap-3">
        {links.map((l) => {
          const url = social[l.key];
          const Icon = l.icon;
          return (
            <a key={l.key} href={url || "#"} target="_blank" rel="noreferrer" className={`flex flex-col items-center gap-2 p-3 rounded-lg border border-gray-100 hover:border-[#e11d2a] hover:bg-red-50/20 ${!url ? "opacity-40 pointer-events-none" : ""}`}>
              <Icon className="w-6 h-6" style={{ color: l.color }} />
              <span className="text-xs font-semibold">{l.label}</span>
            </a>
          );
        })}
      </div>
    </div>
  );
}
